import { render, staticRenderFns } from "./Adserve.vue?vue&type=template&id=28365cc9&scoped=true&"
import script from "./Adserve.vue?vue&type=script&lang=js&"
export * from "./Adserve.vue?vue&type=script&lang=js&"
import style0 from "./Adserve.vue?vue&type=style&index=0&id=28365cc9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28365cc9",
  null
  
)

export default component.exports